import { merge } from 'lodash-es';

const emptyState = {
    booking: {
        map: '',
        eventCode: '',
        selectedTickets: [],
        additionalParams: {},
        assignments: {},
        numAssignmentsInSelection: 0,
        errorMessage: '',
        loading: false,
        items: {},
        products: {},
        isTicketStoreMobileActive: false,
        marketingTitle: '',
        eventName: '',
        bookingLayerVisible: false,
    },
};

export default function (state) {
    const preparedState = merge(emptyState, state);
    const itemsKeys = Object.keys(preparedState.booking.items);
    // eslint-disable-next-line no-underscore-dangle
    preparedState.booking.map = window.__APP_CONFIG__.map || '';

    itemsKeys.forEach((e) => {
        preparedState.booking.items[e].selected = preparedState.booking.items[e].selected || false;
        preparedState.booking.items[e].success = preparedState.booking.items[e].success || true;
        preparedState.booking.items[e].limit = preparedState.booking.items[e].limit || 1;
    });

    return preparedState;
}



// WEBPACK FOOTER //
// ./src/vuex/prepareState.js